import React from 'react';
import classnames from 'classnames';
import * as styles from './base.scss';
export default ({ disabled, className, children, onClick, onClose }) => (React.createElement("div", { className: classnames(styles.scrollable, className, { [styles.disabled]: disabled }), onClick: e => !disabled && onClick && onClick(e) }, React.Children.map(children, c => React.cloneElement(c, { onClose: onClose }))));
